import { WarningTriangle } from '../../../cars/components/V3/icons'

export const FormAlert = ({ errorMessage }: { errorMessage: string }) => {
  return (
    <div className="w-full flex gap-3 align-middle bg-error-background text-error-default py-3 px-4 rounded-md">
      <WarningTriangle /> <div>{errorMessage}</div>
    </div>
  )
}
